module.exports = __webpack_public_path__ + "static/media/calendar.35952dd4.svg";